export const MATERIAL_DEFINITION_TYPES = ['TEST', 'QUALITY_CONTROL', 'LINEARITY'] as const;

export type MaterialDefinitionType = (typeof MATERIAL_DEFINITION_TYPES)[number];

export const isMaterialDefinitionType = (value: unknown): value is MaterialDefinitionType =>
    typeof value === 'string' && (MATERIAL_DEFINITION_TYPES as readonly string[]).includes(value);
